import React from "react";
import { normaliseStatus, toneClass } from "@/lib/statuses";
import { useLang } from "@/contexts/LanguageContext";

/**
 * Renders a status pill for any raw status value (legacy or new vocab).
 * Automatically maps generic labels like "Approved" / "Eligible" onto the
 * product-spec 16-stage vocabulary.
 */
export function StatusPill({ status, className = "" }) {
  const s = normaliseStatus(status);
  const { tv } = useLang();
  return (
    <span
      data-testid={`status-${s.key}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap ${toneClass(s.tone)} ${className}`}
      title={s.label}
    >
      {tv(s.label)}
    </span>
  );
}
